import {
  UPDATE_CONTACTBLOCK,
  UPDATE_CONTACTBLOCK_SUCCESS,
  UPDATE_CONTACTBLOCK_ERROR,

  CREATE_CONTACTBLOCK,
  CREATE_CONTACTBLOCK_SUCCESS,
  CREATE_CONTACTBLOCK_ERROR,

  SAVE_CONTACTBLOCK,
  SAVE_CONTACTBLOCK_SUCCESS,
  SAVE_CONTACTBLOCK_ERROR,

  GET_CONTACTBLOCK_LIST,
  GET_CONTACTBLOCK_LIST_SUCCESS,
  GET_CONTACTBLOCK_LIST_ERROR,
  GET_CONTACTBLOCK,
  GET_CONTACTBLOCK_SUCCESS,
  GET_CONTACTBLOCK_ERROR,
  GET_ORDER_CONTACTBLOCK,
  GET_ORDER_CONTACTBLOCK_SUCCESS,
  GET_ORDER_CONTACTBLOCK_ERROR,

  UPDATE_ORDER_CONTACTBLOCK,
  UPDATE_ORDER_CONTACTBLOCK_SUCCESS,
  UPDATE_ORDER_CONTACTBLOCK_ERROR,

  DELETE_CONTACTBLOCK,
  DELETE_CONTACTBLOCK_SUCCESS,
  DELETE_CONTACTBLOCK_ERROR,

} from "../actions";

export const getOrderContactBlock = (contactBLockId, activityInfo) => {
  return {
    type: GET_ORDER_CONTACTBLOCK,
    payload: { contactBLockId, activityInfo },
  };
};

export const getOrderContactBlockSuccess = (contactBlock) => ({
  type: GET_ORDER_CONTACTBLOCK_SUCCESS,
  payload: contactBlock,
});

export const getOrderContactBlockError = (message) => ({
  type: GET_ORDER_CONTACTBLOCK_ERROR,
  payload: { message },
});

export const getContactBlock = (contactBLockId, activityInfo) => {
  return {
    type: GET_CONTACTBLOCK,
    payload: { contactBLockId, activityInfo},
  };
};

export const getContactBlockSuccess = (contactBlock) => ({
  type: GET_CONTACTBLOCK_SUCCESS,
  payload: contactBlock,
});

export const getContactBlockError = (message) => ({
  type: GET_CONTACTBLOCK_ERROR,
  payload: { message },
});

export const getContactBlockList = (contactId, orderId, recordState, recordType, activityInfo) => {
  return {
    type: GET_CONTACTBLOCK_LIST,
    payload: { contactId, orderId, recordState, recordType, activityInfo },
  };
};

export const getContactBlockListSuccess = (contactBlockList) => ({
  type: GET_CONTACTBLOCK_LIST_SUCCESS,
  payload: contactBlockList,
});

export const getContactBlockListError = (message) => ({
  type: GET_CONTACTBLOCK_LIST_ERROR,
  payload: { message },
});

export const updateContactBlock = (contactBlock, activityInfo) => {
  return {
    type: UPDATE_CONTACTBLOCK,
    payload: { contactBlock, activityInfo },
  };
};

export const updateContactBlockSuccess = (contactBlock) => ({
  type: UPDATE_CONTACTBLOCK_SUCCESS,
  payload: contactBlock,
});

export const updateContactBlockError = (message) => ({
  type: UPDATE_CONTACTBLOCK_ERROR,
  payload: { message },
});

export const updateOrderContactBlock = (contactBlock, activityInfo) => {
  return {
    type: UPDATE_ORDER_CONTACTBLOCK,
    payload: { contactBlock, activityInfo },
  };
};

export const updateOrderContactBlockSuccess = (contactBlock) => ({
  type: UPDATE_ORDER_CONTACTBLOCK_SUCCESS,
  payload: contactBlock,
});

export const updateOrderContactBlockError = (message) => ({
  type: UPDATE_ORDER_CONTACTBLOCK_ERROR,
  payload: { message },
});

export const createContactBlock = (cb) => {
  return {
    type: CREATE_CONTACTBLOCK,
    payload: { cb },
  };
};

export const createContactBlockSuccess = (cb) => ({
  type: CREATE_CONTACTBLOCK_SUCCESS,
  payload: cb,
});

export const createContactBlockError = (message) => ({
  type: CREATE_CONTACTBLOCK_ERROR,
  payload: { message },
});

export const saveContactBlock = (cb, activityInfo) => {
  return {
    type: SAVE_CONTACTBLOCK,
    payload: { cb, activityInfo },
  };
};

export const saveContactBlockSuccess = (cb) => ({
  type: SAVE_CONTACTBLOCK_SUCCESS,
  payload: cb,
});

export const saveContactBlockError = (message) => ({
  type: SAVE_CONTACTBLOCK_ERROR,
  payload: { message },
});

export const trashContactBlock = (contactBlock, activityInfo) => {
  return {
    type: DELETE_CONTACTBLOCK,
    payload: { contactBlock, activityInfo },
  };
};


export const trashContactBlockSuccess = (deletedContactBlock) => ({
  type: DELETE_CONTACTBLOCK_SUCCESS,
  payload: deletedContactBlock,
});

export const trashContactBlockError = (message) => ({
  type: DELETE_CONTACTBLOCK_ERROR,
  payload: { message },
});
